import { render, staticRenderFns } from "./crudSource.vue?vue&type=template&id=49d6d1e2&"
import script from "./crudSource.vue?vue&type=script&lang=js&"
export * from "./crudSource.vue?vue&type=script&lang=js&"
import style0 from "./crudSource.vue?vue&type=style&index=0&id=49d6d1e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports